import React, { Component } from 'react';
import { Switch, Route, withRouter } from 'react-router-dom';
import { Link } from 'react-router-dom';
import Statistics from '../statistics/Statistics';
import $ from 'jquery';
import SupervisorySessions from './SupervisorySessions';
import EscalationSessions from './EscalationSessions';

class SupportTeamTabSettings extends Component {
    componentDidMount() {
        (function () {
            var currentPath = window.location.href;
            var path = window.origin + "/platform/projectmgmt/reports/audit/support-team";
            var path1 = window.origin + "/platform/projectmgmt/reports/audit/support-team/";
            if (currentPath === path || currentPath === path1) {
                $("#escalation-sessions-tab").addClass('active');
            } else if (currentPath.includes('/projectmgmt/reports/audit/support-team/supervisory-sessions')) {
                $("#supervisory-sessions-tab").addClass('active');
            } else {
                $("#" + localStorage.getItem("last-used-support-team-settings-tab")).addClass('active')
            }
            $("#supervisory-sessions-tab,#escalation-sessions-tab")
                .on("click", function () {
                    $("#supervisory-sessions-tab, #escalation-sessions-tab")
                        .removeClass('active');
                    localStorage.setItem("last-used-support-team-settings-tab", $(this)[0].id);
                    $(this).addClass('active')
                })
        })();
    }
    render() {
        return (

            <div id="tabPage">
                <div className="content" style={{ backgroundColor: "#F9F9FB" }}>

                    <link rel="shortcut icon" type="image/png" href="assets/images/bot.ico" />
                    <title> Dheeyantra | Clusters Details</title>
                    {/* Font Awesome Icons */}
                    <link rel="stylesheet" href="plugins/font-awesome/css/font-awesome.min.css" />
                    {/* IonIcons */}
                    <link rel="stylesheet" href="//code.ionicframework.com/ionicons/2.0.1/css/ionicons.min.css" />
                    <link rel="stylesheet" href="assets/fonts/flat-icon/flaticon.css" />
                    {/* Theme style */}
                    <link rel="stylesheet" href="assets/css/adminlte.css" />
                    <link href="https://cdn.jsdelivr.net/npm/gijgo@1.9.6/css/gijgo.min.css" rel="stylesheet" />
                    <link rel="stylesheet" href="assets/css/custom-style.css" />
                    <link rel="stylesheet" href="assets/css/styles.css" />
                    <link rel="stylesheet" href="assets/css/custom-style.css" />
                    <div className="container-fluid" >
                        {/* Nav tabs */}
                        <div className="tab-class">
                            <ul className="nav nav-tabs border-bottom navCluster" >
                                <Link to="/projectmgmt/reports/audit/support-team" className="nav-item"
                                    style={{ textDecoration: 'none' }}>
                                    <li className="nav-link" id="escalation-sessions-tab">
                                        Supervisory Sessions
                                    </li></Link>
                                <Link to="/projectmgmt/reports/audit/support-team/supervisory-sessions" className="nav-item"
                                    style={{ textDecoration: 'none' }}>
                                    <li className="nav-link" id="supervisory-sessions-tab">
                                        Login Information
                                    </li></Link>

                            </ul>
                        </div>
                    </div>
                </div>
                <Switch>
                    <Route path="/projectmgmt/reports/audit/support-team/supervisory-sessions" component={SupervisorySessions}></Route>
                    <Route path="/projectmgmt/reports/audit/support-team" component={EscalationSessions}></Route>
                </Switch>
            </div>

        );
    }
}
export default SupportTeamTabSettings;


// WEBPACK FOOTER //
// ./src/projectmgmt/reports/audit/SupportTeam.js